import Api from "../../axios"

export const getMissingStatusList = async ({startDate, endDate})=>{
    return await Api.get(`/missing_report?start_date=${startDate}&end_date=${endDate}`)
}